import moment from "moment";
import { store } from "../../../../../config/store";
import { openCloseToast } from "../../../../Global/actions";
import trace from "../../../../../helpers/trace";
import helper from "../../../../../helpers/validaciones";
import { numberToDay } from "../../../../../helpers/strings";
import { showToastError, showToastSuccess } from "../../../../Main/actions";

import {
  GetOfficeAchs,
  getAllOpeningsWeek,
  GetAllOpeningsMonth,
  createdOpening,
  getAllQuotes,
  deleteOpeningById,
  GetCenterConfiguration,
  getConfigurationById,
  getAllConfigurationList,
  updateOpening,
} from "../../../../../services/aperturas";
import constants from "../../../../../helpers/constants";


import { GetExcelSiniestrosApi } from "../../../../../services/SiniestrosEmpresa";
import FileSaver from "file-saver";


export const loading = (isLoading) => ({
  type: "LOADING_APERTURAS_SCHEDULER",
  isLoading,
});

export const modalWizardLoading = (isModalWizardLoading) => ({
  type: "LOADING_APERTURA_MODAL_WIZARD",
  isModalWizardLoading,
});

export const setCenterList = (centrosList) => ({
  type: "SET_CENTER_LIST",
  centrosList,
});
export const setAppointmentOpeningsList = (list) => ({
  type: "SET_APPOINTMENT_OPENINGS_LIST",
  list,
});
export const openCloseModalDeleteOpening = (isOpen, id) => ({
  type: "OPEN_CLOSE_MODAL_DELETE_OPENING",
  isOpen,
  id,
});
export const setCenterConfig = (config) => ({
  type: "SET_CENTER_CONFIG_OPENING",
  config,
});
export const setConfiguration = (list) => ({
  type: "SET_CONFIGURATION",
  list,
});
export const setListWorkingDays = (listDaysWorking) => ({
  type: "SET_LIST_WORKING_DAYS",
  listDaysWorking,

});
export const openCloseModalConflictWeek = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_CONFLICT_WEEK",
  isOpen,
});
export const setListExamPool = (listExamPools) => ({
  type: "SET_LIST_EXAM_POOL",
  listExamPools,
});
export const setListExams = (listExams) => ({
  type: "SET_LIST_EXAMS",
  listExams,
});
export const setQuoteList = (listQuotes) => ({
  type: "SET_QUOTES_LIST",
  listQuotes,
});
export const setAppointmentApertura = (data) => ({
  type: "SET_APPOINTMENT",
  data,
});

export const openCloseModalEditWeek = (isOpen, data) => ({
  type: "OPEN_CLOSE_MODAL_EDIT_WEEK",
  isOpen,
  data,
});

export const setCenterIdOpening = (centerId) => ({
  type: "SET_CENTER_ID_OPENING",
  centerId,
});

export const setListExamsCiel = (listCiel) => ({
  type: "SET_LIST_EXAMS_CIEL",
  listCiel,

});
export const setHideShowWizard = (value) => ({
  type: "SET_HIDE_SHOW_WIZARD",
  isPopupWizardOpen: value,
});

export const setStepWizard = (steps) => ({
  type: "SET_STEPS_WIZARD",
  steps,
});
export const setConfigShedulerWizard = (configSchedulerWizard) => ({
  type: "SET_CONFIG_SCHEDULER_WIZARD",
  configSchedulerWizard,
});

export const setOpening = (Opening) => ({
  type: "SET_OPENING",
  Opening,
});
export const setWeekAppointments = (list) => ({
  type: "SET_WEEK_APPOINTMENTS",
  list,
});
export const setAppointmentEditWeek = (data) => ({
  type: "SET_APPOINTMENT_EDIT_WEEK",
  data,
});
export const resetOpeningState = (centerId) => ({
  type: "RESET_OPENING_STATE",
  centerId,
});

export const setFeriadosAdminAperturas = (feriados) => ({
  type: "SET_FERIADOS_ADMIN_APERTURAS",
  feriados,
});
export const setValidationOpening = (validationOpening) => ({
  type: "SET_VALIDATION_OPENING",
  validationOpening,
});

export const setIsDownloadExcel = (isDownloadExcel) => ({
  type: "SET_DOWNLOAD_EXCEL_OPENING",
  isDownloadExcel,
});
export const setNameConflictModal = (isModalNameAndConflictOpen) => ({
  type: "SET_OPEN_CONFLICT_OPEN",
  isModalNameAndConflictOpen,
});
export const resetState = () => ({
  type: "RESET_STATES_OPENING"
})

export const doGetCenters = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await GetOfficeAchs();
    const result = await request.json();
    if (request.status === 200) {
      const centrosList = result.filter((o) => o.Status === 1);
      dispatch(setCenterList(centrosList.sort((a, b) => a.Description.localeCompare(b.Description))));
      dispatch(doGetCenterConfiguration(centrosList[0].Id));
      dispatch(setCenterIdOpening(centrosList[0].Id));
      dispatch(doGetWeekAppointments(centrosList[0].Id));
      dispatch(doGetOpeningsAppointments(centrosList[0].Id));
    } else if (request.status === 400) {
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetCenters", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};
export const doGetCenterConfiguration = (IdCentro) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const config = {};
    const Opening = {};
    const request = await GetCenterConfiguration(IdCentro);
    const response = await request.json();
    if (request.status === 200) {
      const Days = helper.getUnique(response.Days, "DayId").map(e => { if (e.DayId === 7) e.DayId = 0; return e });
      const pivotDays = Days.map((d) => ({ day: numberToDay(d.DayId), since: d.Since, until: d.Until }));
      const sat = pivotDays.find((s) => s.day === constants.sabado); //! == undefined;
      const sun = pivotDays.find((s) => s.day === constants.domingo); // !== undefined;
      const week = pivotDays.find((s) => s.day !== constants.sabado && s.day !== constants.domingo);

      const workDays = [];
      pivotDays.forEach((item) => {
        const pivot = helper.getDaysIndex(item.day);
        workDays.push({ index: pivot.index, day: pivot.name, order: pivot.order });
      });
      const ExamPools = helper.getUnique(response.Pools.map((p) => ({ id: p.PoolId, Name: p.Description, Status: p.Status })), "Name");
      const Exams = helper.getUnique(response.AdditionalExams.map((exam) => ({ id: exam.ExamId, Name: exam.Description })), "Name");
      const Ciel = helper.getUnique(response.PsychologicalExams.map((c) => ({ id: c.ExamId, Name: c.Description })), "Name");

      Opening.IdCentro = response.Id;
      Opening.Id = 0;
      Opening.IdConfig = 0;
      Opening.weekWorking = false;
      Opening.isNewConfig = true;
      Opening.workDays = [];


      config.canOverBookCiel = response.CielOverbook;
      config.maxOverBookCiel = response.CielOverbookedMaximumAmount;
      config.canOverBookOcupational = response.OccupationalOverbook;
      config.maxOverBookOcupational = response.OccupationalOverbookedMaximumAmount;
      config.canOverBookPreocupational = response.WorryingOverbook;
      config.maxOverBookPreocupational = response.WorryingOverbookedMaximumAmount;

      config.minWorkDay = week !== undefined ? week.since : null;
      config.maxWorkDay = week !== undefined ? week.until : null;

      config.minSatWork = sat !== undefined ? sat.since : null;
      config.maxSatWork = sat !== undefined ? sat.until : null;

      config.minSunWork = sun !== undefined ? sun.since : null;
      config.maxSunWork = sun !== undefined ? sun.until : null;
      config.listCiel = Ciel;
      config.listDaysWorking = workDays.sort((a, b) => a.order - b.order);
      var examPoolFilterStatus = ExamPools.filter(s => s.Status === 1);
      config.listExamPools = examPoolFilterStatus;
      config.listExams = Exams;

      dispatch(setCenterConfig(config));
      dispatch(setOpening(Opening));
    } else if (request.status === 400) {
      dispatch(showToastError(request.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetCenterConfiguration:>", error);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
export const doGetListConfigurations = (IdCentro) => async (dispatch) => {
  try {
    const request = await getAllConfigurationList(IdCentro);
    const response = await request.json();
    const list = response.map((p) => ({ IdConfig: p.Id, NameConfig: p.Description }));
    list.push({ IdConfig: 0, NameConfig: "Nueva" });
    dispatch(setConfiguration(list));
  } catch (error) {
    trace.error("doGetListConfigurations", error);
    dispatch(showToastError());
  }
};
export const doGetConfigurations = (Opening, IdConfig) => async (dispatch) => {
  dispatch(modalWizardLoading(true));
  try {
    // solo busco las configuraciones

    const NewOpening = Opening;
    const request = await getConfigurationById(IdConfig);
    const config = await request.json();
    if (request.status === 200) {
      let pivotDays = config.WorkingDaysString.split(",");

      pivotDays = pivotDays.map((d) => {
        const day = numberToDay(parseInt(d, 10));
        const pivot = helper.getDaysIndex(day);
        return { index: pivot.index, day: pivot.name, order: pivot.order };
      });
      const workDays = pivotDays.map((d) => ({ index: d.index, day: d.day }));

      NewOpening.weekWorking = pivotDays.find((s) => s.day !== constants.sabado && s.day !== constants.domingo) !== undefined;
      NewOpening.satWorking = pivotDays.find((s) => s.day === constants.sabado) !== undefined;
      NewOpening.sunWorking = pivotDays.find((s) => s.day === constants.domingo) !== undefined;

      NewOpening.IdConfig = IdConfig;
      NewOpening.isNewConfig = false;

      NewOpening.startWorkDay = NewOpening.weekWorking ? config.StartTime : null;
      NewOpening.endWorkDay = NewOpening.weekWorking ? config.EndTime : null;

      NewOpening.satWorkstart = NewOpening.satWorking ? config.StartTimeSaturday : null;
      NewOpening.satWorkEnd = NewOpening.satWorking ? config.EndTimeSaturday : null;

      NewOpening.sunWorkStart = NewOpening.sunWorking ? config.StartTimeSunday : null;
      NewOpening.sunWorkEnd = NewOpening.sunWorking ? config.EndTimeSunday : null;

      NewOpening.moduleTime = config.ModuleDuration;

      NewOpening.NameOpening = config.Description;
      NewOpening.ExamPools = config.Pools.map((p) => p.Id);
      NewOpening.Exams = config.Exams.filter((i) => i.ExamTypeId === 1).map((i) => i.Id);
      NewOpening.Ciel = config.Exams.filter((i) => i.ExamTypeId === 2).map((i) => i.Id);
      NewOpening.workDays = workDays;
      NewOpening.data = config.Modules;

      dispatch(setOpening(NewOpening));
    } else if (request.status === 400) {
      dispatch(showToastError(config.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetDataToUpdateOpening", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(modalWizardLoading(false));
};

export const doGetOpeningsAppointments = (centerId, start) => async (dispatch) => {
  if (!centerId) return;

  dispatch(loading(true));
  try {
    const startDate = moment(start).startOf("months");
    const endDate = moment(start).endOf("months").add(1, "day");

    const request = await GetAllOpeningsMonth(centerId, startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"));
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setAppointmentOpeningsList(result.map((item) => ({
        ...item,
        text: item.Configuration.Description,
        startDate: new Date(item.StartScheduler),
        endDate: new Date(item.EndScheduler),
      }))));
    } else if (request.status === 400) {
      const result = await request.json();
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetOpeningsAppointments", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetQuotesList = () => async (dispatch) => {
  try {
    const request = await getAllQuotes();
    if (request.status === 200) {
      const result = await request.json();
      const list = [];
      result.forEach((q) => {
        const Quota = {
          Id: q.Id,
          Description: q.Description,
          Overbook: q.Overbook,
          OverbookedMaximumAmount: q.OverbookedMaximumAmount,
          Status: q.Status,
        };
        list.push({
          AmmountQuota: 0,
          AmmountOverQuota: 0,
          Quota,
        });
      });

      dispatch(setQuoteList(list));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error cargar lista de cupos",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    trace.error("doGetQuotesList", e);
    dispatch(showToastError());
  }
};

export const doGetWeekAppointments = (centerId, start) => async (dispatch) => {
  if (!centerId) return;
  dispatch(loading(true));
  try {
    const startDate = moment(start).startOf("isoweek");
    const endDate = moment(start).endOf("isoWeek");

    const request = await getAllOpeningsWeek(centerId, startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"));
    const result = await request.json();
    if (request.status === 200) {
      dispatch(setWeekAppointments(result.map((item) => ({
        ...item,
        startDate: new Date(new Date(item.StartDatetime).setHours(moment(item.StartDatetime).format("HH"), moment(item.StartDatetime).format("mm"), 0, 0)),
        endDate: new Date(new Date(item.EndDatetime).setHours(moment(item.EndDatetime).format("HH"), moment(item.EndDatetime).format("mm"), 0, 0)),
      }))));
    } else if (request.status === 400) {
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (e) {
    trace.error("doGetWeekAppointments", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doUpdateWeekAppointment = (data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const dayOfModule = new Date(data.StartDatetime).getDay();
    const startTime = moment(data.StartDatetime).format("HH:mm");
    const endTime = moment(data.EndDatetime).format("HH:mm");
    const newConfig = {
      EndDate: data.EndDatetime,
      StartDate: data.StartDatetime,
      Id: 0,
      Configuration: {
        Center: data.config.Center,
        Description: data.config.Description,
        Exams: data.config.Exams.map((Id) => ({ Id })),
        Pools: data.config.Pools.map((Id) => ({ Id })),
        Ciel: data.config.Ciel.map((Id) => ({ Id })),
        Id: 0,
        ModuleDuration: data.config.ModuleDuration,
        Modules: [{
          Day: dayOfModule,
          StartTime: startTime,
          EndTime: endTime,
          Quotas: data.Quotas.map((q) => ({
            AmmountOverQuota: q.AmmountOverQuota,
            AmmountQuota: q.AmmountQuota,
            Quota: q.Quota,
          })),
        }],
        StartTime: dayOfModule < 5 ? startTime : null,
        EndTime: dayOfModule < 5 ? endTime : null,
        StartTimeSaturday: dayOfModule > 4 ? startTime : null,
        EndTimeSaturday: dayOfModule > 4 ? endTime : null,
        StartTimeSunday: dayOfModule > 4 ? startTime : null,
        EndTimeSunday: dayOfModule > 4 ? endTime : null,
        WorkingDays: [dayOfModule],
      },
    };

    const request = await createdOpening(newConfig);

    if (request.status === 200) {
      dispatch(showToastSuccess(`Se han editado los cupos del ${moment(data.startDate).format("dddd")} a las ${moment(data.startDate).format("HH:mm")}`));
      dispatch(openCloseModalEditWeek(false, { config: {} }));
      dispatch(openCloseModalConflictWeek(false));

      const state = store.getState().aperturasSel;
      dispatch(doGetOpeningsAppointments(state.centerId, data.startDate));
      dispatch(doGetWeekAppointments(state.centerId, data.StartDate));
    } else if (request.status === 400) {
      dispatch(showToastError());
    } else if (request.status === 406) {
      const response = await request.json();
      dispatch(setValidationOpening({
        quotes: response.QuotaInConflict,
        openValidation: true,
        message: response.Message,
      }));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (e) {
    trace.error("doUpdateWeekAppointment", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doCreateUpdateOpening = (Opening) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let request = {};

    let msg;
    if (Opening.Id === null || Opening.Id === 0) {
      request = await createdOpening(Opening);
      msg = "Creación de Apertura realizada";
    } else {
      request = await updateOpening(Opening);

      msg = "Modificación de Apertura realizada";
    }
    if (request.status === 200) {
      dispatch(showToastSuccess(msg));
      dispatch(setHideShowWizard(false));
      const state = store.getState().aperturasSel;
      dispatch(doGetOpeningsAppointments(state.centerId));
      dispatch(doGetWeekAppointments(state.centerId));
      dispatch(resetOpeningState(state.centerId));
      dispatch(setValidationOpening({
        quotes: 0,
        openValidation: false,
      }));
    } else if (request.status === 400) {
      dispatch(showToastError());
    } else if (request.status === 500) {
      dispatch(showToastError());
    } else if (request.status === 406) {
      const response = await request.json();
      dispatch(setValidationOpening({
        quotes: response.QuotaInConflict,
        openValidation: true,
        message: response.Message,
      }));
      dispatch(setNameConflictModal(true));
    }
  } catch (e) {
    trace.error("doCreateUpdateOpening", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetDataToUpdateOpening = (opSelected, centerId) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const Opening = {};
    const IdConfig = opSelected.Configuration.Id;
    const request = await getConfigurationById(IdConfig);
    const config = await request.json();

    let pivotDays = opSelected.Configuration.WorkingDaysString.split(",");
    pivotDays = pivotDays.map((d) => {
      const day = numberToDay(parseInt(d, 10));
      const pivot = helper.getDaysIndex(day);
      return { index: pivot.index, day: pivot.name, order: pivot.order };
    });
    const workDays = pivotDays.map((d) => ({ index: d.index, day: d.day }));
    Opening.Id = opSelected.Id;
    Opening.IdConfig = IdConfig;
    Opening.IdCentro = centerId;
    Opening.isNewConfig = false;
    Opening.startDate = opSelected.StartDate;
    Opening.endDate = opSelected.EndDate;

    Opening.satWorking = pivotDays.find((s) => s.day === constants.sabado) !== undefined;
    Opening.sunWorking = pivotDays.find((s) => s.day === constants.domingo) !== undefined;
    Opening.ExamPools = config.Pools ? config.Pools.map((p) => p.Id) : [];
    Opening.Exams = config.Exams ? config.Exams.filter((i) => i.ExamTypeId === 1).map((i) => i.Id) : [];
    Opening.Ciel = config.Exams ? config.Exams.filter((i) => i.ExamTypeId === 2).map((i) => i.Id) : [];
    Opening.weekWorking = workDays.find((s) => s.day !== constants.sabado && s.day !== constants.domingo) !== undefined;
    Opening.startWorkDay = Opening.weekWorking ? config.StartTime : null;
    Opening.endWorkDay = Opening.weekWorking ? config.EndTime : null;
    Opening.satWorkstart = Opening.satWorking ? config.StartTimeSaturday : null;
    Opening.satWorkEnd = Opening.satWorking ? config.EndTimeSaturday : null;
    Opening.sunWorkStart = Opening.sunWorking ? config.StartTimeSunday : null;
    Opening.sunWorkEnd = Opening.sunWorking ? config.EndTimeSunday : null;

    Opening.moduleTime = config.ModuleDuration;
    Opening.NameOpening = config.Description;
    Opening.workDays = workDays;
    Opening.data = config.Modules;
    await dispatch(setOpening(Opening));
    dispatch(setStepWizard({
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepSuccess: false,
    }));
    dispatch(setHideShowWizard(true));
  } catch (error) {
    trace.error("doGetDataToUpdateOpening", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }

  dispatch(loading(false));
};

export const doDeleteOpeningById = (id) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await deleteOpeningById(id);
    if (request.status === 200) {
      showToastSuccess();
      const state = store.getState().aperturasSel;
      dispatch(doGetOpeningsAppointments(state.centerId));
      dispatch(doGetWeekAppointments(state.centerId));
      dispatch(openCloseModalDeleteOpening(false, null));
    } else if (request.status === 400) {
      const result = await request.json();
      showToastError(result.Message);
    } else if (request.status === 406) {
      const result = await request.json();
      dispatch(setValidationOpening({
        quotes: result.QuotaInConflict,
        openValidation: true,
        message: result.Message,
      }));
    } else if (request.status === 500) {
      showToastError();
    }
  } catch (e) {
    trace.error("doDeleteOpeningById", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetDataToUpdateWeek = (appointment) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getConfigurationById(appointment.ConfigurationId);
    if (request.status === 200) {
      const result = await request.json();

      const data = {
        ...appointment,
        config: {
          ...result,
          Pools: result.Pools.map((i) => i.Id),
          Ciel: result.Exams.filter((i) => i.ExamTypeId === 2).map((i) => i.Id),
          Exams: result.Exams.filter((i) => i.ExamTypeId === 1).map((i) => i.Id),
        },
      };
      dispatch(openCloseModalEditWeek(true, data));
    } else if (request.status === 400) {
      dispatch(showToastError());
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (e) {
    trace.error("doGetDataToUpdateWeek", e);
    showToastError();
  }
  dispatch(loading(false));
};

export const doGetFeriadosAdmin = (centerId) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const feriados = [
      new Date(2019, 6, 24),
    ];
    dispatch(setFeriadosAdminAperturas(feriados));
  } catch (e) {
    trace.error("doGetFeriadosAdmin", e);
    showToastError();
  }
  dispatch(loading(false));
};

export const doGetExcel = () => async (dispatch) => {
  dispatch(setIsDownloadExcel(true));
  try {
    const header = {
      RutEmpresa: "70360100-6",
      Pagina: 1,
      RegistrosPorPagina: 100000,
      FechaPresentacionInicio: 20180613,
      FechaPresentacionFin: 20190613,
    };
    const request = await GetExcelSiniestrosApi(header);
    if (request !== 0) {
      const file = new Blob([request], { type: "application/xls;base64" });
      FileSaver.saveAs(file, "documento.xlsx");
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error en descargar archivo",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    trace.error("doGetExcel", e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(setIsDownloadExcel(true));
};
